import React, { useCallback } from 'react';
import { Form, FormProps, FormRenderProps } from 'react-final-form';
import InputAdornment from '@mui/material/InputAdornment';
import { Box } from '@mui/material';

import { TextField } from '@occc-app/design-system';

import { ClearIcon } from '../../../icons/importedIcons';
import { IconButton } from '../icon-button';

type SearchFormFieldProps = {
  value?: string;
  clearFormField: () => any;
};

export const SearchFormField: React.FC<SearchFormFieldProps> = ({ value, clearFormField }) => {
  const renderInputAdornment = useCallback(() => {
    return (
      <InputAdornment position='end'>
        <IconButton onClick={clearFormField} size='small'>
          <ClearIcon fontSize='inherit' />
        </IconButton>
      </InputAdornment>
    );
  }, [clearFormField]);

  return (
    <Box
      component={TextField}
      name='search'
      label='Search'
      placeholder='Search by keyword'
      InputProps={{
        endAdornment: value && renderInputAdornment(),
      }}
      size='small'
      maxWidth={320}
    />
  );
};

type SearchFormValues = {
  search?: string;
};
export type SearchFormProps = {
  onSubmit: FormProps<SearchFormValues>['onSubmit'];
  initialValues?: SearchFormValues;
};

export const SearchForm: React.FC<SearchFormProps> = ({ onSubmit, initialValues }) => {
  const renderForm: FormRenderProps<SearchFormValues>['render'] = React.useCallback(
    ({ values, handleSubmit, form }: FormRenderProps<SearchFormValues>) => {
      const clearFormField = () => {
        form.reset();
        onSubmit({ search: undefined }, form);
      };
      return (
        <Box component='form' flex={1} textAlign='right' onSubmit={handleSubmit}>
          <SearchFormField value={values.search} clearFormField={clearFormField} />
        </Box>
      );
    },
    [onSubmit],
  );

  return (
    <Form<SearchFormValues> onSubmit={onSubmit} render={renderForm} initialValues={initialValues} />
  );
};
